import React, { useState } from "react";
import ModalImage from "react-modal-image";
import useUniversalStore from "store/universalStore";
import dayjs from "dayjs";
import { transactionAPI, accountAPI } from "services";
import { ConfirmationModal, Loader } from "components";
import { formatMoney } from "utils";
import useOffcanvasStore from "store/offcanvasStore";

function Txn({ data, setLoader }) {
  const { transactionId, accountId, write, selectedMonth } = useUniversalStore((state) => state);
  const { openOffcanvas } = useOffcanvasStore();


  let attachment = data.get("attachment");
  const isPDF = attachment?.includes(".pdf");
  //TODO : If filename contains invalid characters, then change filename to valid filename
  const isImage = attachment?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const text = data.get("detail");

  // useEffect(() => {
  //   console.log("data", data);
  // }, [data]);

  const handleModalOpen = () => {
    const modal = new window.bootstrap.Modal(document.getElementById('deleteTxnInKhataModal'));
    modal.show();
  };

  const deletetransaction = async () => {
    setLoader(true);
    try {
      await transactionAPI.deleteTransaction(transactionId);
      //Reset the transactionId
      write({
        transactionId: null,
        accounts: await accountAPI.getAccounts(),
        transactions: await transactionAPI.getTransactionsByAccountIdWithMonth(accountId, selectedMonth),
      });
    } catch (err) {
      console.error("deletetransaction error: ", err);
    } finally {
      setLoader(false);
    }
  };

  const editTransaction = () => {
    openOffcanvas("editTxn");
    write({ transactionId: data.id });
  }

  const cancelledView = () => {
    return (
      <div className="d-flex pe-0 p-md-0 justify-content-center align-items-start">
        <div className="col-4 col-md-3 pe-0 text-end" style={{ minWidth: "min-content" }}>
          <i className="fs-xmd-smaller text-decoration-line-through text-muted text-nowrap">
            {formatMoney(data.get("amount"))}
          </i>
        </div>
        <div className="col-8 col-md-9 ps-2">
          <div className="d-flex flex-wrap col-12">
            <div className="col-12 text-start">
              <small className="text-break text-wrap text-decoration-line-through text-muted">{data.get("detail")}</small>
              <div align="right">
                <small align="right"><i className="text-decoration-line-through text-muted">{dayjs(data.get("date")).format('DD MMM')}</i></small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const handleDownload = () => {
  //   const link = document.createElement('a');
  //   link.href = attachment;
  //   link.target = "_blank"
  //   link.download = 'filename.jpg'; 
  //   link.click();
  // };

  const normalView = () => {
    return (
      <div className="d-flex pe-0 p-md-0 justify-content-center align-items-start">
        <div className="col-4 col-md-3 pe-0 text-end" style={{ minWidth: "min-content" }}>
          <i className="fs-xmd-smaller text-nowrap">
            {formatMoney(Math.abs(data.get("amount")))}
          </i>
        </div>
        <div className="col-8 col-md-9 ps-2">
          <div className="d-flex flex-wrap col-12">
            <div className="col-12 text-start">
              <div className="flex-fill">
                <small className="text-break text-wrap">{text}</small>
              </div>
              <div align="right" className="d-flex justify-content-end align-items-center fs-xmd-smaller">
                <small align="right"><i >{dayjs(data.get("date")).format('DD MMM')}</i></small>
                <div className="ps-2">
                  {data.id ? (
                    <div className="dropdown">
                      <a
                        className="text-black btn p-0 p-md-1 bg-not-transparent-on-hover w-auto"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        title="More options"
                      >
                        <span className="bi bi-three-dots-vertical"></span>
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end row w-auto">
                        <li className="col-12">
                          <button className="w-100 btn btn-outline-app rounded"
                            onClick={editTransaction}
                          >
                            <span className="bi bi-pencil-fill"> Edit</span>
                          </button>
                        </li>
                        <li className="col-12 py-1">
                          <button className="w-100 btn btn-app rounded fs-6"
                            onClick={() => {
                              write({ transactionId: data.id });
                              handleModalOpen()
                            }}
                          >
                            <i className="bi bi-trash"> Delete</i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div align="left">
              {isImage &&
                <div className="container p-0" >
                  <ModalImage
                    small={attachment}
                    large={attachment}
                    hideDownload={true}
                    hideZoom={true}
                    alt={data.get("detail")}
                    className="uploadbillpreview"
                  />
                </div>
              }
              {isPDF && (<a role="button"
                href={attachment}
                target="_blank"
                className="cursor-pointer">
                <i className="bi bi-file-pdf-fill text-app fs-1"
                />
              </a>)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <li className="list-group-item bg-transparent">
      <div className="row ">
        {data.get("cancelled") ? cancelledView() : normalView()}
        <ConfirmationModal id="deleteTxnInKhataModal" onClick={deletetransaction} />
      </div>
    </li>
  );
}

export default Txn;
